var map = {
	"./02_hero_desktop.jpg": 237,
	"./02_hero_mobile.jpg": 238,
	"./02_hero_tablet.jpg": 239,
	"./04_hero_desktop.jpg": 240,
	"./04_hero_mobile.jpg": 241,
	"./04_hero_tablet.jpg": 242,
	"./06_hero_desktop.jpg": 243,
	"./06_hero_mobile.jpg": 244,
	"./06_hero_tablet.jpg": 245,
	"./07_hero_desktop.jpg": 246,
	"./07_hero_mobile.jpg": 247,
	"./07_hero_tablet.jpg": 248,
	"./08_hero_desktop.jpg": 249,
	"./08_hero_mobile.jpg": 250,
	"./08_hero_tablet.jpg": 251,
	"./10_hero_desktop.jpg": 252,
	"./10_hero_mobile.jpg": 253,
	"./10_hero_tablet.jpg": 254,
	"./11b_hero_desktop.jpg": 255,
	"./11b_hero_mobile.jpg": 256,
	"./11b_hero_tablet.jpg": 257,
	"./12b_hero_desktop.jpg": 258,
	"./12b_hero_mobile.jpg": 259,
	"./12b_hero_tablet.jpg": 260,
	"./Corteva_Do_More_with_Less.jpg": 261,
	"./Corteva_From_Data_to_Decision.jpg": 262,
	"./Tanzania-Queen-and-Son-small.jpg": 263,
	"./Thailand.jpg": 264,
	"./artOfPrecision-desktop.jpg": 265,
	"./brazil_old_pastures.jpg": 266,
	"./cracking-the-code.jpg": 267,
	"./farmingWithNoRain-desktop.jpg": 268,
	"./foodByPrescription-desktop.jpg": 269,
	"./howTheWorldGrow-desktop.jpg": 270,
	"./seeds-of-change-desktop.jpg": 271,
	"./silicon-farm-thumbnail.jpg": 272
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 514;